export default __webpack_public_path__ + "static/media/Join_Icon.cbd80e10.png";